// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sQ4c","label":"styles_label__2oQkv"};